<template>
  <div class="pdf-generator" style="overflow-x: hidden; overflow-y: auto; height: 100%;">
    <div class="report-controls" v-if="true">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="车牌号">
          <el-input v-model="searchForm.vehiclePlate" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadReportData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="generatePdf">生成PDF</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 210mm;margin: 0 auto;">
      <!-- 要转换为PDF的内容 -->
      <div id="pdf-content" class="pdf-content">
        <!-- 报告标题 -->
        <Header />

        <VehicleBasicInfo />

        <VehicleRunInfo style="margin-top: 20px;" />
        <VehicleWorkInfo style="margin-top: 20px;" />
        <VehicleReportData style="margin-top: 20px;" />
        <!-- <div class="report-section no-page-break-before">
      

      </div> -->

        <!-- <div class="report-section no-page-break-before">
     

      </div> -->




        <!-- 5. 综合评估说明 -->
        <!-- <div class="report-section">
        <h2>五、综合评估</h2>
        <div class="evaluation">
          <div class="evaluation-score">
            <div class="score-value">{{ reportData.evaluation.score }}</div>
            <div class="score-label">综合评分</div>
          </div>
          <div class="evaluation-level">
            <el-rate v-model="reportData.evaluation.score" :max="100" disabled show-score></el-rate>
          </div>

          <div class="evaluation-content">
            <h3>评估总结</h3>
            <p>{{ reportData.evaluation.summary }}</p>

            <h3>优势分析</h3>
            <ul>
              <li v-for="(item, index) in reportData.evaluation.strengths" :key="index">{{ item }}</li>
            </ul>

            <h3>改进建议</h3>
            <ul>
              <li v-for="(item, index) in reportData.evaluation.suggestions" :key="index">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div> -->

        <!-- 页脚 -->
        <!-- <div class="footer">
        <p>报告生成日期：{{ currentDate }} | 数据仅供参考，请以实际情况为准</p>
      </div> -->
      </div>
    </div>

  </div>
</template>

<script>
// import * as echarts from 'echarts'
import Header from './header.vue'
import VehicleBasicInfo from './vehicle_basicinfo.vue'

import html2pdf from 'html2pdf.js'
import VehicleInfo from './vehicleinfo.vue'
import VehicleRunInfo from './vehicle_runinfo.vue'
import VehicleWorkInfo from './vehicle_workinfo.vue'
import VehicleReportData from './vehicle_report_data.vue'
export default {
  name: 'VehicleReport',
  components: {
    Header,
    VehicleBasicInfo,
    VehicleInfo,
    VehicleRunInfo,
    VehicleWorkInfo,
    VehicleReportData
  },
  data() {
    return {
      currentDate: '',

      searchForm: {
        vehiclePlate: '',
        dateRange: []
      },
      reportData: {
        dateRange: '',
        vehicleInfo: {
          plateNumber: '',
          vehicleType: '',
          company: '',
          engineNumber: '',
          frameNumber: '',
          purchaseDate: '',
          fuelType: '',
          seatingCapacity: '',
          status: ''
        },
        summary: {
          totalMileage: 0,
          averageSpeed: 0,
          totalFuelConsumption: 0,
          fuelConsumptionPerHundredKm: 0,
          totalRuntime: 0,
          drivingTime: 0,
          idleTime: 0,
          doorOpenCount: 0
        },
        alarmInfo: {
          brakeAlarmCount: 0,
          brakeAlarmDesc: '',
          airFilterAlarmCount: 0,
          airFilterAlarmDesc: ''
        },
        drivingBehavior: [],
        overspeedInfo: [],
        speedDistribution: [],
        rpmDistribution: [],
        evaluation: {
          score: 0,
          summary: '',
          strengths: [],
          suggestions: []
        }
      },

    }
  },
  mounted() {
    // 初始化日期
    this.currentDate = new Date().toLocaleDateString()
    // 加载默认数据
    this.loadReportData()
  },
  methods: {
    // 加载报告数据
    loadReportData() {
      // 模拟API调用，实际项目中应该替换为真实的API请求
      // 这里使用模拟数据填充报告
      this.reportData = this.getMockReportData()

      // 延迟初始化图表，确保DOM已更新
      setTimeout(() => {
        this.initCharts()
      }, 100)
    },

    // 初始化图表
    initCharts() {



      // 监听窗口大小变化，重绘图表
      window.addEventListener('resize', this.handleResize)
    },

    // 初始化车速分布图


    // 初始化转速分布图

    // 处理窗口大小变化
    handleResize() {

    },

    // 生成PDF
    generatePdf() {
      // 获取要转换为PDF的元素
      const element = document.getElementById('pdf-content')

      // 配置选项
      const opt = {
        margin: 10,
        filename: `车辆运行报告_${this.reportData.vehicleInfo.plateNumber || '未知'}_${new Date().toLocaleDateString().replace(/\//g, '-')}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2, // 提高分辨率
          useCORS: true,
          logging: false
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: {
          mode: ['avoid-all', 'css'], // 避免在特定元素处分页
          before: '.no-page-break-before', // 这些类名的元素前不分页
          after: '.no-page-break-after', // 这些类名的元素后不分页
          avoid: '.avoid-page-break' // 避免在这些元素内分页
        }
      }

      // 生成PDF
      html2pdf().from(element).set(opt).save()
    },

    // 格式化数字
    formatNumber(num) {
      if (typeof num !== 'number') return num
      return num.toLocaleString('zh-CN')
    },

    // 格式化时长
    formatDuration(seconds) {
      if (!seconds && seconds !== 0) return '00:00:00'

      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = seconds % 60

      return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        secs.toString().padStart(2, '0')
      ].join(':')
    },

    // 获取严重程度标签类型
    getSeverityType(severity) {
      switch (severity) {
        case '轻微':
          return 'info'
        case '中等':
          return 'warning'
        case '严重':
          return 'danger'
        default:
          return 'success'
      }
    },

    // 获取模拟报告数据
    getMockReportData() {
      const dateRange = this.searchForm.dateRange.length
        ? `${this.searchForm.dateRange[0].toLocaleDateString()} 至 ${this.searchForm.dateRange[1].toLocaleDateString()}`
        : '最近30天'

      return {
        dateRange,
        vehicleInfo: {
          plateNumber: this.searchForm.vehiclePlate || '京A12345',
          vehicleType: '大型客车',
          company: '北京公交集团',
          engineNumber: 'DE12345678',
          frameNumber: 'LFV3A24G8D3123456',
          purchaseDate: '2022-01-15',
          fuelType: '柴油',
          seatingCapacity: '50人',
          status: '运营中'
        },
        summary: {
          totalMileage: 5687.5,
          averageSpeed: 32.5,
          totalFuelConsumption: 1256.8,
          fuelConsumptionPerHundredKm: 22.1,
          totalRuntime: 28650, // 秒
          drivingTime: 25320, // 秒
          idleTime: 3330, // 秒
          doorOpenCount: 234
        },
        alarmInfo: {
          brakeAlarmCount: 2,
          brakeAlarmDesc: '建议检查制动系统',
          airFilterAlarmCount: 1,
          airFilterAlarmDesc: '需要更换空气滤清器'
        },
        drivingBehavior: [
          { type: '急加速', count: 15, severity: '中等' },
          { type: '急减速', count: 23, severity: '严重' },
          { type: '急转弯', count: 8, severity: '轻微' },
          { type: '长时间怠速', count: 5, severity: '中等' }
        ],
        overspeedInfo: [
          { level: '轻度超速 (≤10%)', count: 12, avgDuration: '45秒', maxSpeed: 66 },
          { level: '中度超速 (10%-20%)', count: 3, avgDuration: '30秒', maxSpeed: 72 },
          { level: '严重超速 (>20%)', count: 0, avgDuration: '0秒', maxSpeed: 0 }
        ],
        speedDistribution: [
          { range: '0-20km/h', duration: 7850, percentage: 31.0, avgFuelConsumption: 28.5 },
          { range: '20-40km/h', duration: 12450, percentage: 49.1, avgFuelConsumption: 22.3 },
          { range: '40-60km/h', duration: 4520, percentage: 17.8, avgFuelConsumption: 19.8 },
          { range: '60-80km/h', duration: 500, percentage: 2.0, avgFuelConsumption: 21.5 },
          { range: '>80km/h', duration: 0, percentage: 0.0, avgFuelConsumption: 0 }
        ],
        rpmDistribution: [
          { range: '0-1000rpm', duration: 3350, percentage: 13.2, remark: '怠速或低负荷' },
          { range: '1000-2000rpm', duration: 15620, percentage: 61.7, remark: '经济转速区间' },
          { range: '2000-3000rpm', duration: 5850, percentage: 23.1, remark: '中负荷运行' },
          { range: '>3000rpm', duration: 500, percentage: 2.0, remark: '高负荷运行' }
        ],
        evaluation: {
          score: 82,
          summary: '该车整体运行状况良好，经济性指标处于合理范围，驾驶员操作基本规范，但存在少量不良驾驶行为需要改进。',
          strengths: [
            '大部分时间运行在经济转速区间',
            '无严重超速行为',
            '平均油耗处于正常水平',
            '车辆基本状况良好'
          ],
          suggestions: [
            '减少急加速和急减速行为，可进一步降低油耗',
            '定期检查制动系统，确保行车安全',
            '按计划更换空气滤清器',
            '尽量减少长时间怠速，节能环保'
          ]
        }
      }
    }
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize)



  }
}
</script>

<style scoped>
.pdf-generator {
  padding: 20px;
}

.report-controls {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 5px;
}

.search-form {
  display: flex;
  align-items: center;
}

.search-form .el-form-item {
  margin-right: 15px;
}

.pdf-content {
  width: 100%;
  /* A4宽度 */
  margin: 0 auto;
  padding: 10mm;
  background-color: white;

}


.report-meta {
  color: #666;
  font-size: 14px;
}

.report-meta span {
  margin: 0 15px;
}

/* 章节样式 */
/* PDF分页控制样式 */
.report-section {
  margin-bottom: 40px;
  page-break-inside: avoid;
  /* 尽量避免在章节内分页 */
}

.no-page-break-before {
  page-break-before: avoid;
}

.no-page-break-after {
  page-break-after: avoid;
}

.avoid-page-break {
  page-break-inside: avoid;
}

.data-grid,
.chart-container {
  page-break-inside: avoid;
  /* 避免在数据网格和图表中间分页 */
}

/* 调整章节间距，使PDF分页更合理 */
.report-section {
  margin-top: 30px;
  margin-bottom: 30px;
}

.report-section h2 {
  color: #337ab7;
  font-size: 20px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.report-section h3 {
  color: #555;
  font-size: 16px;
  margin: 20px 0 10px 0;
}

/* 车辆信息样式 */
.vehicle-info {

  border-radius: 5px;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-item {
  flex: 1;
  display: flex;
  align-items: center;
}

.info-item label {
  font-weight: bold;
  color: #555;
  margin-right: 10px;
  min-width: 80px;
}

.info-item .active {
  color: #52c41a;
  font-weight: bold;
}

/* 汇总数据样式 */
.summary-data {
  margin-top: 20px;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.data-card {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #e8e8e8;
}

.data-value {
  font-size: 24px;
  font-weight: bold;
  color: #337ab7;
  margin-bottom: 8px;
}

.data-label {
  font-size: 14px;
  color: #666;
}

/* 表格样式 */
.alarm-table,
.behavior-table,
.overspeed-table,
.chart-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.alarm-table th,
.alarm-table td,
.behavior-table th,
.behavior-table td,
.overspeed-table th,
.overspeed-table td,
.chart-table th,
.chart-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.alarm-table th,
.behavior-table th,
.overspeed-table th,
.chart-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333;
}

.alarm-table tr:nth-child(even),
.behavior-table tr:nth-child(even),
.overspeed-table tr:nth-child(even),
.chart-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* 图表容器样式 */
.chart-container {
  margin: 20px 0;
}

.chart {
  width: 100%;
  height: 400px;
}

.chart-data {
  margin-top: 20px;
}

/* 评估样式 */
.evaluation {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
}

.evaluation-score {
  text-align: center;
  margin-bottom: 20px;
}

.score-value {
  font-size: 48px;
  font-weight: bold;
  color: #337ab7;
  line-height: 1;
}

.score-label {
  font-size: 16px;
  color: #666;
  margin-top: 5px;
}

.evaluation-level {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.evaluation-content {
  text-align: left;
}

.evaluation-content p {
  line-height: 1.6;
  color: #555;
  margin-bottom: 15px;
}

.evaluation-content ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

.evaluation-content li {
  margin-bottom: 8px;
  line-height: 1.5;
  color: #555;
}

/* 页脚样式 */
.footer {
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
  text-align: center;
  font-size: 14px;
  color: #999;
}

/* 按钮样式 */
.generate-btn {
  margin: 20px 0;
  padding: 10px 20px;
  background-color: #337ab7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.generate-btn:hover {
  background-color: #286090;
}
</style>